export default __webpack_public_path__ + "static/media/right.6661fc44.svg";